import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueMeta from 'vue-meta';
import Rollbar from 'rollbar';
import CalendarPlugin from '@quasar/quasar-ui-qcalendar';
import App from './App';
import store from './store';
import makeRouter from './router';
import boot from './boot';
import apolloProvider from './apollo-provider';
import globalMixin from './mixins/global';

// Import Quasar
import Quasar from 'quasar';
import '@quasar/extras/material-icons/material-icons.css';
import 'quasar/dist/quasar.css';
import '@quasar/quasar-ui-qcalendar/dist/index.css';
import './scss/index.scss';

window.Vue = Vue;

/* eslint-disable-next-line */
// require('./assets/quasar.umd.min.js');

// Set the Rollbar instance in the Vue prototype
// before creating the first Vue instance.
// This ensures it is available in the same way for every
// instance in your app.
Vue.prototype.$rollbar = new Rollbar({
  accessToken: window.ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: window.ROLLBAR_ENV,
  payload: {
    code_version: window.APP_VERSION || '1.0.0'
  }
});

// If you have already set up a global error handler,
// just add `vm.$rollbar.error(err)` to the top of it.
// If not, this simple example will preserve the app's existing
// behavior while also reporting uncaught errors to Rollbar.
Vue.config.errorHandler = (err, vm) => {
  vm.$rollbar.error(err);
  throw err; // rethrow
};

Vue.use(Quasar, {
  config: {
    brand: {
      primary: '#1976d2',
      secondary: '#26a69a',
      accent: '#9c27b0',
      dark: '#1d1d1d',
      positive: '#21ba45',
      negative: '#c10015',
      info: '#31ccec',
      warning: '#f2c037'
    }
  }
});

Vue.use(CalendarPlugin);
Vue.config.productionTip = false;
Vue.mixin(globalMixin);

Vue.use(Vuelidate);

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

// Set global app configuration
Vue.prototype.$appConfig = {
  name: window.APP_NAME,
  version: window.APP_VERSION,
  environment: window.APP_ENV,
  apiUrl: window.API_URL,
  serverTimezone: window.SERVER_TIMEZONE || 'America/New_York',
  mapConfig: {
    googleMapApiKey: window.GOOGLE_MAP_API_KEY,
    mapBoxApiKey: window.MAP_BOX_API_KEY
  }
};

Vue.prototype.$zipLocationsCenters = {};

const router = makeRouter(apolloProvider);

const app = new Vue({
  el: '#q-app',
  store,
  router,
  apolloProvider,
  components: { App },
  template: '<App/>'
});

boot([], {
  Vue,
  app,
  router,
  store
});
